import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSsnCard24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M7.62484 10.125H11.3748M7.62484 12.625H9.72484M14.2915 10.125H16.3748V13.0416H14.2915V10.125ZM5.12484 18.0416H18.8748C19.3351 18.0416 19.7082 17.6686 19.7082 17.2083V6.79165C19.7082 6.33141 19.3351 5.95831 18.8748 5.95831H5.12484C4.6646 5.95831 4.2915 6.3314 4.2915 6.79165V17.2083C4.2915 17.6686 4.6646 18.0416 5.12484 18.0416Z" stroke={iconColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoSsnCard24;